module.exports = __webpack_public_path__ + "static/media/44.6cc15fca.png";